import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ExpandableList extends Component {
  static propTypes = {
    collection: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired,
      active: PropTypes.bool.isRequired,
    })),
    limit: PropTypes.number,
    expansionLinkText: PropTypes.string,
    expanded: PropTypes.bool,
    listClass: PropTypes.string,
    listItemClass: PropTypes.string,
  }

  static defaultProps = {
    collection: [],
    limit: 4,
    expansionLinkText: 'See more',
    expanded: false,
    listClass: '',
    listItemClass: '',
  }

  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded || (this.props.collection.length <= this.props.limit),
    };
  }

  expand = () => {
    this.setState({ expanded: true });
  }

  limitedCollection() {
    if (this.state.expanded) {
      return this.props.collection;
    }
    return this.props.collection.slice(0, this.props.limit);
  }

  renderCollectionItem(item) {
    return (
      <li className={this.props.listItemClass} key={item.key}>
        <a href={item.href} className={item.active ? 'is-active' : ''}>
          {item.text}
        </a>
      </li>
    );
  }

  renderCollection() {
    return (
      this.limitedCollection().map(
        (item) => this.renderCollectionItem(item)
      )
    );
  }

  render() {
    return (
      <div>
        <ul className={this.props.listClass}>
          { this.renderCollection() }
        </ul>

        { !this.state.expanded &&
          <a className="u-mt-3 u-flex u-text-sm u-cursor-pointer" onClick={this.expand}>
            {this.props.expansionLinkText}
          </a>
        }
      </div>
    );
  }
}
